import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../../vme-common.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { JobListItemComponent } from './job-list-item.component';
import { ChecklistCategoryItemModule } from '../../../components/checklist-category-item/checklist-category-item.module';

const routes: Routes = [
  { path: '', component: JobListItemComponent, data: { title: 'Job Alert' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobListItemRoutingModule {}

@NgModule({
  imports: [
    JobListItemRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ChecklistCategoryItemModule,
  ],
  declarations: [JobListItemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class JobListItemModule {}
